<template>
    <div class="col-12 col-lg-5 col-md-6" v-html="body_content">
        
    </div>
    <div class="col-12 col-lg-7 col-md-6 order-sm-first">
        <div class="partnership-image-container">
            <img class="lazy" :data-src="image_url" alt="">
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    body_content:{ type: String, default:'' },
    image_url: { type: String, default:'' }
  },
  methods: {},
};
</script>